export type ModuleTemplate = 'Table' | 'Sortable' | 'Calendar' | 'Hierarchy' | 'Map' | 'Tiles' | 'Settings';
export type PermissionScope = 'All' | 'Mine' | 'Selected';
export type PermissionType = 'All' | 'Access' | 'Resource';
export type ModalSize = 'md' | 'xl' | 'xxl';

export interface TemplateProperties
{
    canAdd: boolean;
    canExport: boolean;
    editOnModal: boolean;
    modalSize: ModalSize;
    scrollableModal: boolean;
    hasResourcePermissions: boolean;
    // Collection
    enableFilters?: boolean;
    customisableColumns?: boolean;
    // Sortable
    sortPositionColumn?: string;
    // Calendar
    calendarDisplayColumn?: string;
    calendarStartDateColumn?: string;
    calendarEndDateColumn?: string;
    // Hierarchy
    hierarchyRelationColumn?: string;
    hierarchyDisplayColumn?: string;
    // Map
    mapDisplayColumn?: string;
    mapLocalizationColumn?: string;
    mapIconColumn?: string;
    mapColorColumn?: string;
    mapDescriptionColumn?: string;
    mapImageColumn?: string;
    mapZoom?: number;
    mapCenterLatitude?: number;
    mapCenterLongitude?: number;
    // Tiles
    tilesDisplayColumn?: string;
    tilesImageColumn?: string;

}
export type TemplateProperty = keyof TemplateProperties;

export const ModuleTemplateOptions = (): Option<ModuleTemplate>[] => ([
    { value: 'Table', text: $t('[[[Dane tabelaryczne]]]') },
    { value: 'Sortable', text: $t('[[[Lista sortowalna]]]') },
    { value: 'Settings', text: $t('[[[Pojedynczy formularz]]]') },
    { value: 'Calendar', text: $t('[[[Kalendarz]]]') },
    { value: 'Hierarchy', text: $t('[[[Hierarchia]]]') },
    { value: 'Map', text: $t('[[[Mapa]]]') },
    { value: 'Tiles', text: $t('[[[Kafelki]]]') }
]);
export const PermissionScopeOptions = (): Option<PermissionScope>[] => ([
    { value: 'All', text: $t('[[[Pełny]]]') },
    { value: 'Mine', text: $t('[[[Moje dokumenty]]]') },
    { value: 'Selected', text: $t('[[[Wybrane dokumenty]]]') }
]);
export const ModalSizeOptions = (): Option<ModalSize>[] => ([
    { value: 'md', text: $t('[[[Mały]]]') },
    { value: 'xl', text: $t('[[[Średni]]]') },
    { value: 'xxl', text: $t('[[[Duży]]]') }
]);

export const ModuleTemplateSettings: Record<ModuleTemplate, TemplateProperty[]> = {
    Table: [
        'canAdd',
        'canExport',
        'editOnModal',
        'modalSize',
        'scrollableModal',
        'hasResourcePermissions',
        'enableFilters',
        'customisableColumns'
    ],
    Sortable: [
        'canAdd',
        'editOnModal',
        'modalSize',
        'scrollableModal',
        'hasResourcePermissions',
        'customisableColumns',
        'sortPositionColumn'
    ],
    Calendar: [
        'canAdd',
        'editOnModal',
        'modalSize',
        'scrollableModal',
        'hasResourcePermissions',
        'enableFilters',
        'calendarDisplayColumn',
        'calendarStartDateColumn',
        'calendarEndDateColumn'
    ],
    Hierarchy: [
        'canAdd',
        'editOnModal',
        'modalSize',
        'scrollableModal',
        'hasResourcePermissions',
        'customisableColumns',
        'hierarchyRelationColumn',
        'hierarchyDisplayColumn'
    ],
    Map: [
        'canAdd',
        'editOnModal',
        'modalSize',
        'scrollableModal',
        'hasResourcePermissions',
        'enableFilters',
        'mapDisplayColumn',
        'mapLocalizationColumn',
        'mapDescriptionColumn',
        'mapImageColumn',
        'mapColorColumn',
        'mapIconColumn',
        'mapZoom',
        'mapCenterLatitude',
        'mapCenterLongitude'
    ],
    Tiles: [
        'canAdd',
        'editOnModal',
        'modalSize',
        'scrollableModal',
        'hasResourcePermissions',
        'enableFilters',
        'tilesDisplayColumn',
        'tilesImageColumn'
    ],
    Settings: []
};

export interface SectionItem
{
    id: string;
    symbol: string;
    name: string;
    displayName: Record<string, string>;
    formId: number;
    template: ModuleTemplate;
    isHidden: boolean;
    columns: Columns;
    filters: Filters;
    permissions: PermissionsGroup[];
    features: FeaturesList;
    settings: TemplateProperties;
}

export interface PermissionsGroup
{
    items: PermissionItem[];
}
export interface PermissionItem
{
    value: string;
    name: string;
    scope: PermissionScope;
}

export interface FeaturesList
{
    access: FeaturePermissions;
    create: FeaturePermissions;
    view: FeaturePermissions;
    update: FeaturePermissions;
    delete: FeaturePermissions;
    accept: FeaturePermissions;
    manage: FeaturePermissions;
    export: FeaturePermissions;
}

export interface FeaturePermissions
{
    permissions: string[];
    condition: 'And' | 'Or';
    type: PermissionType;
}
